// const hideArrowsClasses = ['opacity-0!', 'pointer-events-none!'];

(async () => {
  if (document.querySelector('.splide')) {
    const Splide = await import('@splidejs/splide').then((mod) => mod.Splide);

    const imageSliders =
      document.querySelectorAll<HTMLDivElement>('.imageSlider');

    imageSliders.forEach((imageSlider) => {
      new Splide(imageSlider, {
        pagination: false,
        rewind: false,
      }).mount();
    });
  }
})();

export {};
